export default __webpack_public_path__ + "static/media/neocal.1d3191ad.png";